export default __webpack_public_path__ + "48b74eb02ef98fd242135a5da2129bc6.svg";